module.exports = __webpack_public_path__ + "static/img/tjykd.89c29b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/tjykd.png
// module id = 6mIR
// module chunks = 0